/**
 * Flatten a multidimensional array.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
 */
export const flatten = <T = unknown>(arr: T[] | T[][]) => arr.flat(Infinity) as T[]
